module.exports = __webpack_public_path__ + "img/dobby_logo.bdd84ca2.png";